export const METAL_RESOURCE = 1;

export const CRYSTAL_RESOURCE = 2;

export const DEUTERIUM_RESOURCE = 3;

export const ENERGY_RESOURCE = 4;